import axios from "axios";

export const enterpriseSearchEngine = (data, jwtToken) => {
    console.log("sending data", data);
    const headers = {
        'Authorization': `Bearer ${jwtToken}`,
        'Content-Type': 'application/json',
    };
    return axios.post(
        "https://dev.genai.krtrimaiq.ai:6003/search_docs",
        data,
        {headers: headers}
    );
};

export const dvdBiBot = (data) => {
    // return axios.post("http://dev.genai.krtrimaiq.ai:8998/chat", data);
    // return axios.post("https://bi-bot.krtrimaiq.ai/chat", data);
    return axios.post("https://mlmachine.krtrimaiq.ai:5000/chat",data);
};

export const informationExtractionGetKeys = (data) => {
    console.log(data);
    return axios.post("https://languageapi.krtrimaiq.ai:6007/upload_pdf", data)
};

export const informationExtractionGetValues = (data) => {
    console.log(data);
    return axios.post("https://languageapi.krtrimaiq.ai:6007/get-values", data)
};

export const mmsSearch = (data) => {
    return axios.post('https://languageapi.krtrimaiq.ai:5604/query',data);
};

export const mmsSearchTeri= (data) => {
    return axios.post('https://mlmachine.krtrimaiq.ai:5612/query',data);
};
export const mmsSpeak= (data) => {
    return axios.post('https://languageapi.krtrimaiq.ai:5602/speech_text',data);
};

export const mmsFileSearchTeri= (data) => {
    return axios.post('https://mlmachine.krtrimaiq.ai:5608/upload_temp_document',data);
};
export const mmsFileUpload= (data) => {
    return axios.post('https://languageapi.krtrimaiq.ai:5604/upload',data)  
};
export const mmsSearchSpeech= (data) => {
    return axios.post('https://languageapi.krtrimaiq.ai:5502/speech',data);
};
export const mmsSearchFeedback= (data) => {
    return axios.post('https://languageapi.krtrimaiq.ai:5604/usr_feedback',data);
};
export const mmsSearchFeedbackTeri= (data) => {
    return axios.post('https://mlmachine.krtrimaiq.ai:5608/usr_feedback',data);
};

export const mmsExternal= (data) => {
    return axios.post('https://languageapi.krtrimaiq.ai:5604/broad',data);
};

export const handwritten= (data) => {
    return axios.post('https://languageapi.krtrimaiq.ai:5221/get-htr',data);
};
export const scanned= (data) => {
    return axios.post('https://languageapi.krtrimaiq.ai:5103/file-translate',data);
};
export const mmsTeriFileURL = (data) => {
    return axios.post('https://mlmachine.krtrimaiq.ai:5608/download', data);
};
export const mmsTeriStreaming = (data) => {
    return axios.post('https://mlmachine.krtrimaiq.ai:5612/query', data);
};

